@file:OptIn(InternalResourceApi::class)

package helpmycity.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/helpmycity.shared.generated.resources/"

@delegate:ResourceContentHash(1_188_885_548)
internal val Res.string.field_location: StringResource by lazy {
      StringResource("string:field_location", "field_location", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7853, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7353, 38),
      ))
    }

@delegate:ResourceContentHash(-1_171_274_017)
internal val Res.string.field_location_hint: StringResource by lazy {
      StringResource("string:field_location_hint", "field_location_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7757, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7277, 75),
      ))
    }

@delegate:ResourceContentHash(1_057_381_811)
internal val Res.string.field_neighborhood: StringResource by lazy {
      StringResource("string:field_neighborhood", "field_neighborhood", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7896, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7392, 42),
      ))
    }

@delegate:ResourceContentHash(-1_192_622_746)
internal val Res.string.field_notes_source: StringResource by lazy {
      StringResource("string:field_notes_source", "field_notes_source", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7939, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7435, 46),
      ))
    }

@delegate:ResourceContentHash(-2_068_927_484)
internal val Res.string.field_priority: StringResource by lazy {
      StringResource("string:field_priority", "field_priority", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7986, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7482, 34),
      ))
    }

@delegate:ResourceContentHash(-1_037_729_254)
internal val Res.string.field_reporter_email: StringResource by lazy {
      StringResource("string:field_reporter_email", "field_reporter_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8021, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7517, 36),
      ))
    }

@delegate:ResourceContentHash(-1_123_463_428)
internal val Res.string.field_reporter_hint: StringResource by lazy {
      StringResource("string:field_reporter_hint", "field_reporter_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8078, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7554, 107),
      ))
    }

@delegate:ResourceContentHash(-1_920_129_229)
internal val Res.string.field_reporter_name: StringResource by lazy {
      StringResource("string:field_reporter_name", "field_reporter_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8186, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7662, 35),
      ))
    }

@delegate:ResourceContentHash(-875_880_332)
internal val Res.string.field_reporter_phone: StringResource by lazy {
      StringResource("string:field_reporter_phone", "field_reporter_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8222, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7698, 36),
      ))
    }

@delegate:ResourceContentHash(-166_041_121)
internal val Res.string.field_reporter_section: StringResource by lazy {
      StringResource("string:field_reporter_section", "field_reporter_section", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8263, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7735, 74),
      ))
    }

@delegate:ResourceContentHash(1_695_983_331)
internal val Res.string.field_requested_action: StringResource by lazy {
      StringResource("string:field_requested_action", "field_requested_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8338, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7810, 58),
      ))
    }

@delegate:ResourceContentHash(-2_125_264_188)
internal val Res.string.field_required: StringResource by lazy {
      StringResource("string:field_required", "field_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8405, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7869, 34),
      ))
    }

@delegate:ResourceContentHash(1_279_268_089)
internal val Res.string.field_title: StringResource by lazy {
      StringResource("string:field_title", "field_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8541, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7981, 47),
      ))
    }

@delegate:ResourceContentHash(1_539_538_733)
internal val Res.string.field_title_hint: StringResource by lazy {
      StringResource("string:field_title_hint", "field_title_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8444, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7904, 76),
      ))
    }

@delegate:ResourceContentHash(-1_767_055_050)
internal val Res.string.form_error_description_required: StringResource by lazy {
      StringResource("string:form_error_description_required", "form_error_description_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8593, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8029, 71),
      ))
    }

@delegate:ResourceContentHash(1_719_571_405)
internal val Res.string.form_error_location_required: StringResource by lazy {
      StringResource("string:form_error_location_required", "form_error_location_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8661, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8101, 64),
      ))
    }

@delegate:ResourceContentHash(-1_682_665_126)
internal val Res.string.form_error_title_required: StringResource by lazy {
      StringResource("string:form_error_title_required", "form_error_title_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8730, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8166, 61),
      ))
    }

@delegate:ResourceContentHash(1_365_086_032)
internal val Res.string.geocode_no_match: StringResource by lazy {
      StringResource("string:geocode_no_match", "geocode_no_match", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8800, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8228, 112),
      ))
    }

@delegate:ResourceContentHash(-1_587_133_944)
internal val Res.string.geocode_resolved: StringResource by lazy {
      StringResource("string:geocode_resolved", "geocode_resolved", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8909, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8341, 40),
      ))
    }

@delegate:ResourceContentHash(987_782_148)
internal val Res.string.geocode_searching: StringResource by lazy {
      StringResource("string:geocode_searching", "geocode_searching", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8958, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8382, 61),
      ))
    }

@delegate:ResourceContentHash(1_925_980_764)
internal val Res.string.geocode_unavailable: StringResource by lazy {
      StringResource("string:geocode_unavailable", "geocode_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9020, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8444, 151),
      ))
    }

@delegate:ResourceContentHash(-1_744_563_018)
internal val Res.string.issues_add: StringResource by lazy {
      StringResource("string:issues_add", "issues_add", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9192, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8596, 38),
      ))
    }

@delegate:ResourceContentHash(-1_014_114_728)
internal val Res.string.issues_empty_body: StringResource by lazy {
      StringResource("string:issues_empty_body", "issues_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9239, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8635, 89),
      ))
    }

@delegate:ResourceContentHash(-426_116_498)
internal val Res.string.issues_empty_filtered_body: StringResource by lazy {
      StringResource("string:issues_empty_filtered_body", "issues_empty_filtered_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9317, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8725, 106),
      ))
    }

@delegate:ResourceContentHash(-1_166_314_986)
internal val Res.string.issues_empty_filtered_title: StringResource by lazy {
      StringResource("string:issues_empty_filtered_title", "issues_empty_filtered_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9400, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8832, 75),
      ))
    }

@delegate:ResourceContentHash(-1_531_328_904)
internal val Res.string.issues_empty_title: StringResource by lazy {
      StringResource("string:issues_empty_title", "issues_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9476, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8908, 46),
      ))
    }

@delegate:ResourceContentHash(1_427_914_737)
internal val Res.string.issues_filter_clear: StringResource by lazy {
      StringResource("string:issues_filter_clear", "issues_filter_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9535, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8955, 47),
      ))
    }

@delegate:ResourceContentHash(1_998_173_502)
internal val Res.string.issues_search_clear: StringResource by lazy {
      StringResource("string:issues_search_clear", "issues_search_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9583, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9003, 43),
      ))
    }

@delegate:ResourceContentHash(-578_260_921)
internal val Res.string.issues_search_hint: StringResource by lazy {
      StringResource("string:issues_search_hint", "issues_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9639, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9047, 46),
      ))
    }

@delegate:ResourceContentHash(1_868_255_677)
internal val Res.string.issues_title: StringResource by lazy {
      StringResource("string:issues_title", "issues_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9686, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9094, 48),
      ))
    }

@delegate:ResourceContentHash(-1_538_319_508)
internal val Res.string.location_pin_add: StringResource by lazy {
      StringResource("string:location_pin_add", "location_pin_add", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9739, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9143, 44),
      ))
    }

@delegate:ResourceContentHash(1_777_603_381)
internal val Res.string.location_pin_approximate: StringResource by lazy {
      StringResource("string:location_pin_approximate", "location_pin_approximate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9788, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9188, 120),
      ))
    }

@delegate:ResourceContentHash(928_715_351)
internal val Res.string.location_pin_clear: StringResource by lazy {
      StringResource("string:location_pin_clear", "location_pin_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9925, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9309, 42),
      ))
    }

@delegate:ResourceContentHash(1_080_125_063)
internal val Res.string.location_pin_coordinates: StringResource by lazy {
      StringResource("string:location_pin_coordinates", "location_pin_coordinates", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9976, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9352, 56),
      ))
    }

@delegate:ResourceContentHash(871_984_771)
internal val Res.string.location_pin_edit: StringResource by lazy {
      StringResource("string:location_pin_edit", "location_pin_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10041, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9409, 49),
      ))
    }

@delegate:ResourceContentHash(653_509_331)
internal val Res.string.location_pin_hide: StringResource by lazy {
      StringResource("string:location_pin_hide", "location_pin_hide", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10091, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9459, 41),
      ))
    }

@delegate:ResourceContentHash(-1_010_993_002)
internal val Res.string.location_pin_hint: StringResource by lazy {
      StringResource("string:location_pin_hint", "location_pin_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10137, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9501, 149),
      ))
    }

@delegate:ResourceContentHash(-1_992_238_898)
internal val Res.string.map_filter_all_neighborhoods: StringResource by lazy {
      StringResource("string:map_filter_all_neighborhoods", "map_filter_all_neighborhoods", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10303, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9651, 60),
      ))
    }

@delegate:ResourceContentHash(-1_804_935_717)
internal val Res.string.map_legend_title: StringResource by lazy {
      StringResource("string:map_legend_title", "map_legend_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10368, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9712, 40),
      ))
    }

@delegate:ResourceContentHash(507_102_436)
internal val Res.string.map_no_located_issues: StringResource by lazy {
      StringResource("string:map_no_located_issues", "map_no_located_issues", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10417, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9753, 109),
      ))
    }

@delegate:ResourceContentHash(662_150_547)
internal val Res.string.map_no_matching_issues: StringResource by lazy {
      StringResource("string:map_no_matching_issues", "map_no_matching_issues", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10551, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9863, 90),
      ))
    }

@delegate:ResourceContentHash(993_196_744)
internal val Res.string.map_title: StringResource by lazy {
      StringResource("string:map_title", "map_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10650, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9954, 21),
      ))
    }

@delegate:ResourceContentHash(1_684_447_244)
internal val Res.string.nav_back: StringResource by lazy {
      StringResource("string:nav_back", "nav_back", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10676, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9976, 28),
      ))
    }

@delegate:ResourceContentHash(561_539_920)
internal val Res.string.nav_board: StringResource by lazy {
      StringResource("string:nav_board", "nav_board", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10705, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10005, 25),
      ))
    }

@delegate:ResourceContentHash(-1_981_566_070)
internal val Res.string.nav_list: StringResource by lazy {
      StringResource("string:nav_list", "nav_list", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10735, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10031, 24),
      ))
    }

@delegate:ResourceContentHash(993_196_744)
internal val Res.string.nav_map: StringResource by lazy {
      StringResource("string:nav_map", "nav_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10764, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10056, 19),
      ))
    }

@delegate:ResourceContentHash(-1_811_149_453)
internal val Res.string.nav_review: StringResource by lazy {
      StringResource("string:nav_review", "nav_review", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10788, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10076, 26),
      ))
    }

@delegate:ResourceContentHash(-1_169_823_553)
internal val Res.string.new_issue_submit: StringResource by lazy {
      StringResource("string:new_issue_submit", "new_issue_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10867, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10151, 32),
      ))
    }

@delegate:ResourceContentHash(-1_318_296_333)
internal val Res.string.new_issue_submitted: StringResource by lazy {
      StringResource("string:new_issue_submitted", "new_issue_submitted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10819, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10103, 47),
      ))
    }

@delegate:ResourceContentHash(-1_744_563_018)
internal val Res.string.new_issue_title: StringResource by lazy {
      StringResource("string:new_issue_title", "new_issue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10900, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10184, 43),
      ))
    }

@delegate:ResourceContentHash(-1_731_324_128)
internal val Res.string.page_title: StringResource by lazy {
      StringResource("string:page_title", "page_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10952, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10228, 34),
      ))
    }

@delegate:ResourceContentHash(-43_991_938)
internal val Res.string.photo_add: StringResource by lazy {
      StringResource("string:photo_add", "photo_add", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10987, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10263, 33),
      ))
    }

@delegate:ResourceContentHash(1_127_651_162)
internal val Res.string.photo_alt: StringResource by lazy {
      StringResource("string:photo_alt", "photo_alt", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11025, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10297, 57),
      ))
    }

@delegate:ResourceContentHash(391_471_942)
internal val Res.string.photo_remove: StringResource by lazy {
      StringResource("string:photo_remove", "photo_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11079, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10355, 28),
      ))
    }

@delegate:ResourceContentHash(-1_187_479_183)
internal val Res.string.photo_section: StringResource by lazy {
      StringResource("string:photo_section", "photo_section", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11108, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10384, 29),
      ))
    }

@delegate:ResourceContentHash(1_919_957_280)
internal val Res.string.priority_high: StringResource by lazy {
      StringResource("string:priority_high", "priority_high", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11138, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10414, 29),
      ))
    }

@delegate:ResourceContentHash(1_635_923_790)
internal val Res.string.priority_low: StringResource by lazy {
      StringResource("string:priority_low", "priority_low", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11168, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10444, 24),
      ))
    }

@delegate:ResourceContentHash(509_312_711)
internal val Res.string.priority_medium: StringResource by lazy {
      StringResource("string:priority_medium", "priority_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11197, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10469, 31),
      ))
    }

@delegate:ResourceContentHash(342_613_868)
internal val Res.string.profile_admin_everything: StringResource by lazy {
      StringResource("string:profile_admin_everything", "profile_admin_everything", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11229, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10501, 136),
      ))
    }

@delegate:ResourceContentHash(-1_608_556_431)
internal val Res.string.profile_areas: StringResource by lazy {
      StringResource("string:profile_areas", "profile_areas", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11644, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10856, 37),
      ))
    }

@delegate:ResourceContentHash(2_069_527_571)
internal val Res.string.profile_areas_citywide: StringResource by lazy {
      StringResource("string:profile_areas_citywide", "profile_areas_citywide", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11406, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10638, 50),
      ))
    }

@delegate:ResourceContentHash(1_335_756_109)
internal val Res.string.profile_areas_none: StringResource by lazy {
      StringResource("string:profile_areas_none", "profile_areas_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11457, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10689, 166),
      ))
    }

@delegate:ResourceContentHash(191_470_814)
internal val Res.string.profile_edit: StringResource by lazy {
      StringResource("string:profile_edit", "profile_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11682, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10894, 36),
      ))
    }

@delegate:ResourceContentHash(-542_421_386)
internal val Res.string.profile_export_csv: StringResource by lazy {
      StringResource("string:profile_export_csv", "profile_export_csv", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12009, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11177, 54),
      ))
    }

@delegate:ResourceContentHash(1_317_481_168)
internal val Res.string.profile_export_csv_body: StringResource by lazy {
      StringResource("string:profile_export_csv_body", "profile_export_csv_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11723, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10931, 159),
      ))
    }

@delegate:ResourceContentHash(-237_150_906)
internal val Res.string.profile_export_csv_failed: StringResource by lazy {
      StringResource("string:profile_export_csv_failed", "profile_export_csv_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11907, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11091, 85),
      ))
    }

@delegate:ResourceContentHash(-484_707_553)
internal val Res.string.profile_guest_body: StringResource by lazy {
      StringResource("string:profile_guest_body", "profile_guest_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12068, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11232, 150),
      ))
    }

@delegate:ResourceContentHash(1_708_576_303)
internal val Res.string.profile_guest_title: StringResource by lazy {
      StringResource("string:profile_guest_title", "profile_guest_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12223, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11383, 63),
      ))
    }

@delegate:ResourceContentHash(1_096_838_905)
internal val Res.string.profile_manage_users: StringResource by lazy {
      StringResource("string:profile_manage_users", "profile_manage_users", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12437, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11589, 52),
      ))
    }

@delegate:ResourceContentHash(-1_638_952_941)
internal val Res.string.profile_manage_users_body: StringResource by lazy {
      StringResource("string:profile_manage_users_body", "profile_manage_users_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12287, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11447, 141),
      ))
    }

@delegate:ResourceContentHash(-239_035_626)
internal val Res.string.profile_open: StringResource by lazy {
      StringResource("string:profile_open", "profile_open", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12490, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11642, 36),
      ))
    }

@delegate:ResourceContentHash(739_839_430)
internal val Res.string.profile_rejected_body: StringResource by lazy {
      StringResource("string:profile_rejected_body", "profile_rejected_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12523, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11679, 173),
      ))
    }

@delegate:ResourceContentHash(2_032_717_150)
internal val Res.string.profile_resident_note: StringResource by lazy {
      StringResource("string:profile_resident_note", "profile_resident_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12697, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11853, 181),
      ))
    }

@delegate:ResourceContentHash(1_886_276_183)
internal val Res.string.profile_role: StringResource by lazy {
      StringResource("string:profile_role", "profile_role", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12879, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12035, 28),
      ))
    }

@delegate:ResourceContentHash(-239_035_626)
internal val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12904, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12064, 37),
      ))
    }

@delegate:ResourceContentHash(-1_640_859_291)
internal val Res.string.rejected_empty_body: StringResource by lazy {
      StringResource("string:rejected_empty_body", "rejected_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12938, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12102, 119),
      ))
    }

@delegate:ResourceContentHash(-1_622_259_964)
internal val Res.string.rejected_empty_title: StringResource by lazy {
      StringResource("string:rejected_empty_title", "rejected_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13074, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12222, 56),
      ))
    }

@delegate:ResourceContentHash(1_141_525_994)
internal val Res.string.rejected_intro: StringResource by lazy {
      StringResource("string:rejected_intro", "rejected_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13139, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12279, 170),
      ))
    }

@delegate:ResourceContentHash(-262_533_271)
internal val Res.string.rejected_title: StringResource by lazy {
      StringResource("string:rejected_title", "rejected_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13306, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12450, 46),
      ))
    }

@delegate:ResourceContentHash(1_753_558_509)
internal val Res.string.resolution_confirm: StringResource by lazy {
      StringResource("string:resolution_confirm", "resolution_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13357, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12497, 46),
      ))
    }

@delegate:ResourceContentHash(793_509_906)
internal val Res.string.resolution_edit: StringResource by lazy {
      StringResource("string:resolution_edit", "resolution_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13416, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12544, 43),
      ))
    }

@delegate:ResourceContentHash(2_017_342_217)
internal val Res.string.resolution_hint: StringResource by lazy {
      StringResource("string:resolution_hint", "resolution_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13464, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12588, 87),
      ))
    }

@delegate:ResourceContentHash(2_005_337_705)
internal val Res.string.resolution_label: StringResource by lazy {
      StringResource("string:resolution_label", "resolution_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13556, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12676, 52),
      ))
    }

@delegate:ResourceContentHash(27_425_042)
internal val Res.string.resolution_required: StringResource by lazy {
      StringResource("string:resolution_required", "resolution_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13609, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12729, 99),
      ))
    }

@delegate:ResourceContentHash(-1_443_356_389)
internal val Res.string.resolution_title: StringResource by lazy {
      StringResource("string:resolution_title", "resolution_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13717, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12829, 40),
      ))
    }

@delegate:ResourceContentHash(-1_629_241_562)
internal val Res.string.review_approve: StringResource by lazy {
      StringResource("string:review_approve", "review_approve", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13827, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12943, 34),
      ))
    }

@delegate:ResourceContentHash(-1_665_604_774)
internal val Res.string.review_approved_note: StringResource by lazy {
      StringResource("string:review_approved_note", "review_approved_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13758, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12870, 72),
      ))
    }

@delegate:ResourceContentHash(-108_166_864)
internal val Res.string.review_issue_gone: StringResource by lazy {
      StringResource("string:review_issue_gone", "review_issue_gone", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13862, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12978, 73),
      ))
    }

@delegate:ResourceContentHash(-484_169_150)
internal val Res.string.review_not_permitted: StringResource by lazy {
      StringResource("string:review_not_permitted", "review_not_permitted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13936, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13052, 112),
      ))
    }

@delegate:ResourceContentHash(-1_895_947_832)
internal val Res.string.review_pending_manager: StringResource by lazy {
      StringResource("string:review_pending_manager", "review_pending_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14057, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13165, 142),
      ))
    }

@delegate:ResourceContentHash(255_516_352)
internal val Res.string.review_pending_submitter: StringResource by lazy {
      StringResource("string:review_pending_submitter", "review_pending_submitter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14188, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13308, 180),
      ))
    }

@delegate:ResourceContentHash(-1_036_498_988)
internal val Res.string.review_queue_count: StringResource by lazy {
      StringResource("string:review_queue_count", "review_queue_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14373, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13489, 58),
      ))
    }

@delegate:ResourceContentHash(1_660_067_713)
internal val Res.string.review_queue_empty_body: StringResource by lazy {
      StringResource("string:review_queue_empty_body", "review_queue_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14440, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13548, 99),
      ))
    }

@delegate:ResourceContentHash(-109_325_905)
internal val Res.string.review_queue_empty_title: StringResource by lazy {
      StringResource("string:review_queue_empty_title", "review_queue_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14564, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13648, 56),
      ))
    }

@delegate:ResourceContentHash(-790_449_111)
internal val Res.string.review_queue_no_scope_body: StringResource by lazy {
      StringResource("string:review_queue_no_scope_body", "review_queue_no_scope_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14621, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13705, 142),
      ))
    }

@delegate:ResourceContentHash(816_862_436)
internal val Res.string.review_queue_no_scope_title: StringResource by lazy {
      StringResource("string:review_queue_no_scope_title", "review_queue_no_scope_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14776, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13848, 63),
      ))
    }

@delegate:ResourceContentHash(-1_759_564_752)
internal val Res.string.review_queue_title: StringResource by lazy {
      StringResource("string:review_queue_title", "review_queue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14856, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13912, 50),
      ))
    }

@delegate:ResourceContentHash(366_649_885)
internal val Res.string.review_reject: StringResource by lazy {
      StringResource("string:review_reject", "review_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15527, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14559, 29),
      ))
    }

@delegate:ResourceContentHash(-2_128_478_535)
internal val Res.string.review_reject_confirm: StringResource by lazy {
      StringResource("string:review_reject_confirm", "review_reject_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14915, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13963, 49),
      ))
    }

@delegate:ResourceContentHash(1_053_213_239)
internal val Res.string.review_reject_reason_hint: StringResource by lazy {
      StringResource("string:review_reject_reason_hint", "review_reject_reason_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 14969, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14013, 157),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("field_location", Res.string.field_location)
  map.put("field_location_hint", Res.string.field_location_hint)
  map.put("field_neighborhood", Res.string.field_neighborhood)
  map.put("field_notes_source", Res.string.field_notes_source)
  map.put("field_priority", Res.string.field_priority)
  map.put("field_reporter_email", Res.string.field_reporter_email)
  map.put("field_reporter_hint", Res.string.field_reporter_hint)
  map.put("field_reporter_name", Res.string.field_reporter_name)
  map.put("field_reporter_phone", Res.string.field_reporter_phone)
  map.put("field_reporter_section", Res.string.field_reporter_section)
  map.put("field_requested_action", Res.string.field_requested_action)
  map.put("field_required", Res.string.field_required)
  map.put("field_title", Res.string.field_title)
  map.put("field_title_hint", Res.string.field_title_hint)
  map.put("form_error_description_required", Res.string.form_error_description_required)
  map.put("form_error_location_required", Res.string.form_error_location_required)
  map.put("form_error_title_required", Res.string.form_error_title_required)
  map.put("geocode_no_match", Res.string.geocode_no_match)
  map.put("geocode_resolved", Res.string.geocode_resolved)
  map.put("geocode_searching", Res.string.geocode_searching)
  map.put("geocode_unavailable", Res.string.geocode_unavailable)
  map.put("issues_add", Res.string.issues_add)
  map.put("issues_empty_body", Res.string.issues_empty_body)
  map.put("issues_empty_filtered_body", Res.string.issues_empty_filtered_body)
  map.put("issues_empty_filtered_title", Res.string.issues_empty_filtered_title)
  map.put("issues_empty_title", Res.string.issues_empty_title)
  map.put("issues_filter_clear", Res.string.issues_filter_clear)
  map.put("issues_search_clear", Res.string.issues_search_clear)
  map.put("issues_search_hint", Res.string.issues_search_hint)
  map.put("issues_title", Res.string.issues_title)
  map.put("location_pin_add", Res.string.location_pin_add)
  map.put("location_pin_approximate", Res.string.location_pin_approximate)
  map.put("location_pin_clear", Res.string.location_pin_clear)
  map.put("location_pin_coordinates", Res.string.location_pin_coordinates)
  map.put("location_pin_edit", Res.string.location_pin_edit)
  map.put("location_pin_hide", Res.string.location_pin_hide)
  map.put("location_pin_hint", Res.string.location_pin_hint)
  map.put("map_filter_all_neighborhoods", Res.string.map_filter_all_neighborhoods)
  map.put("map_legend_title", Res.string.map_legend_title)
  map.put("map_no_located_issues", Res.string.map_no_located_issues)
  map.put("map_no_matching_issues", Res.string.map_no_matching_issues)
  map.put("map_title", Res.string.map_title)
  map.put("nav_back", Res.string.nav_back)
  map.put("nav_board", Res.string.nav_board)
  map.put("nav_list", Res.string.nav_list)
  map.put("nav_map", Res.string.nav_map)
  map.put("nav_review", Res.string.nav_review)
  map.put("new_issue_submit", Res.string.new_issue_submit)
  map.put("new_issue_submitted", Res.string.new_issue_submitted)
  map.put("new_issue_title", Res.string.new_issue_title)
  map.put("page_title", Res.string.page_title)
  map.put("photo_add", Res.string.photo_add)
  map.put("photo_alt", Res.string.photo_alt)
  map.put("photo_remove", Res.string.photo_remove)
  map.put("photo_section", Res.string.photo_section)
  map.put("priority_high", Res.string.priority_high)
  map.put("priority_low", Res.string.priority_low)
  map.put("priority_medium", Res.string.priority_medium)
  map.put("profile_admin_everything", Res.string.profile_admin_everything)
  map.put("profile_areas", Res.string.profile_areas)
  map.put("profile_areas_citywide", Res.string.profile_areas_citywide)
  map.put("profile_areas_none", Res.string.profile_areas_none)
  map.put("profile_edit", Res.string.profile_edit)
  map.put("profile_export_csv", Res.string.profile_export_csv)
  map.put("profile_export_csv_body", Res.string.profile_export_csv_body)
  map.put("profile_export_csv_failed", Res.string.profile_export_csv_failed)
  map.put("profile_guest_body", Res.string.profile_guest_body)
  map.put("profile_guest_title", Res.string.profile_guest_title)
  map.put("profile_manage_users", Res.string.profile_manage_users)
  map.put("profile_manage_users_body", Res.string.profile_manage_users_body)
  map.put("profile_open", Res.string.profile_open)
  map.put("profile_rejected_body", Res.string.profile_rejected_body)
  map.put("profile_resident_note", Res.string.profile_resident_note)
  map.put("profile_role", Res.string.profile_role)
  map.put("profile_title", Res.string.profile_title)
  map.put("rejected_empty_body", Res.string.rejected_empty_body)
  map.put("rejected_empty_title", Res.string.rejected_empty_title)
  map.put("rejected_intro", Res.string.rejected_intro)
  map.put("rejected_title", Res.string.rejected_title)
  map.put("resolution_confirm", Res.string.resolution_confirm)
  map.put("resolution_edit", Res.string.resolution_edit)
  map.put("resolution_hint", Res.string.resolution_hint)
  map.put("resolution_label", Res.string.resolution_label)
  map.put("resolution_required", Res.string.resolution_required)
  map.put("resolution_title", Res.string.resolution_title)
  map.put("review_approve", Res.string.review_approve)
  map.put("review_approved_note", Res.string.review_approved_note)
  map.put("review_issue_gone", Res.string.review_issue_gone)
  map.put("review_not_permitted", Res.string.review_not_permitted)
  map.put("review_pending_manager", Res.string.review_pending_manager)
  map.put("review_pending_submitter", Res.string.review_pending_submitter)
  map.put("review_queue_count", Res.string.review_queue_count)
  map.put("review_queue_empty_body", Res.string.review_queue_empty_body)
  map.put("review_queue_empty_title", Res.string.review_queue_empty_title)
  map.put("review_queue_no_scope_body", Res.string.review_queue_no_scope_body)
  map.put("review_queue_no_scope_title", Res.string.review_queue_no_scope_title)
  map.put("review_queue_title", Res.string.review_queue_title)
  map.put("review_reject", Res.string.review_reject)
  map.put("review_reject_confirm", Res.string.review_reject_confirm)
  map.put("review_reject_reason_hint", Res.string.review_reject_reason_hint)
}
